/* Journey unica brand privati — conferma all'aggiunta al carrello (spec §3.4.5).
   Misurato 2026-09-05: il tema ha gia' il form AJAX (theme.AjaxProduct: fetch su /cart/add.js, emette
   `ajaxProduct:added`), ma lo istanzia SOLO se cartType === 'drawer' (theme.js:7134). Il valore vivo e' 'page'.
   theme.js e' compilato e non si tocca: lo istanziamo da qui, in modalita' page. Il cassetto resta com'e'. */
(function () {
  'use strict';

  /* theme.js:2812-2848 (compilato, non si tocca): addItemFromForm non ha .catch e `status.loading' e'
     privato al modulo (chiuso nell'IIFE di theme.AjaxProduct). Se /cart/add.js risponde con qualcosa che
     non e' JSON valido (blip di rete, pagina di sfida bot) la promise rigetta, `status.loading' resta
     true per sempre e ogni submit successivo su QUALSIASI form del tema ritorna in silenzio senza
     ricaricare la pagina. Prima (POST nativa) l'utente vedeva almeno la pagina di sfida e poteva
     riprovare. Rete di sicurezza: se ne' ajaxProduct:added ne' ajaxProduct:error arrivano entro ~8s dal
     submit, sottomettiamo il form nativamente — bypassa i listener JS, stesso comportamento di oggi. */
  function armaWatchdog(form) {
    form.addEventListener('submit', function () {
      if (form.__wnnWatchdog) clearTimeout(form.__wnnWatchdog);   // un solo watchdog vivo per form
      form.__wnnWatchdog = setTimeout(function () {
        form.__wnnWatchdog = null;
        HTMLFormElement.prototype.submit.call(form);
      }, 8000);
    });
    function sgancia() {
      if (form.__wnnWatchdog) { clearTimeout(form.__wnnWatchdog); form.__wnnWatchdog = null; }
    }
    form.addEventListener('ajaxProduct:added', sgancia);
    form.addEventListener('ajaxProduct:error', sgancia);
  }

  function armaForm(root) {
    if (!window.theme || !theme.AjaxProduct || !theme.settings || theme.settings.cartType === 'drawer') return;
    (root || document).querySelectorAll('form.product-single__form').forEach(function (form) {
      if (form.dataset.wnnAjax) return;             // idempotente: una sola istanza per form
      form.dataset.wnnAjax = '1';
      new theme.AjaxProduct(form);
      armaWatchdog(form);
    });
  }

  // wnn-toast-focus:start
  /* M1 (G1150): il popup e' aria-modal, quindi Tab gira fra il primo e l'ultimo elemento focalizzabile; null = decide il browser. */
  function prossimoFocus(items, attivo, indietro) {
    if (!items.length) return null;
    var primo = items[0], ultimo = items[items.length - 1];
    var dentro = items.indexOf(attivo) >= 0;
    if (indietro) return !dentro || attivo === primo ? ultimo : null;
    return !dentro || attivo === ultimo ? primo : null;
  }
  // wnn-toast-focus:end

  // wnn-toast-ritorno:start
  /* Prove a vista G1150 (US 390): fra il click e il popup il focus puo' passare altrove (banner cookie invisibile). Si torna al
     bottone cliccato; se non e' piu' nella pagina, al ripiego (primo focalizzabile del form prodotto); null = decide il browser. */
  function ritornoFocus(apertoDa, nellaPagina, ripiego) {
    return apertoDa && nellaPagina(apertoDa) ? apertoDa : ripiego || null;
  }
  // wnn-toast-ritorno:end

  // wnn-toast-foto:start
  /* M3 (G1150): la foto del popup e' larga 80 px; il CDN di Shopify la ridimensiona col parametro width. 240 = 80 x DPR 3. */
  function fotoPiccola(url) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=240');
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
  }
  // wnn-toast-foto:end

  // wnn-toast-taglia:start
  /* Prove a vista G1150: la taglia «OS» si legge «Taglia unica» (cart.wnn.toast_one_size), anche in «OS / Nero». */
  function taglia(titolo, unica) {
    return String(titolo).split(' / ').map(function (v) { return v.trim().toUpperCase() === 'OS' && unica ? unica : v; }).join(' / ');
  }
  // wnn-toast-taglia:end

  var toast = document.querySelector('[data-wnn-toast]');
  var prima = null;   // il punto della pagina da cui si e' aperto il popup: ci torna il focus alla chiusura
  var apertoDa = null;   // l'ultimo bottone di aggiunta cliccato: vale piu' del focus del momento

  function testo(chiave) { return (toast && toast.dataset[chiave]) || ''; }

  function righeDa(product) {
    if (!product) return [];
    if (Array.isArray(product.items)) return product.items;   // /cart/add.js con items[]
    if (Array.isArray(product)) return product;
    return [product];                                           // /cart/add.js con un solo articolo
  }

  function escape(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function prezzo(cents) {
    if (cents == null || !window.theme || !theme.Currency || !theme.settings) return '';
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
  }

  /* Popup del commento 15: foto, brand, nome, taglia e prezzo della variante. Lo stepper B2B manda piu' righe dello
     stesso prodotto: al posto della taglia la riga «N pezzi in K taglie» e il prezzo delle righe sommate. */
  function scheda(items) {
    var it = items[0] || {};
    var dettaglio, importo;
    if (items.length > 1) {
      var pezzi = items.reduce(function (a, r) { return a + (Number(r.quantity) || 0); }, 0);
      dettaglio = testo('tPieces').replace('[n]', pezzi).replace('[k]', items.length);
      importo = items.reduce(function (a, r) { return a + (Number(r.final_line_price) || 0); }, 0);
    } else {
      dettaglio = it.variant_title && it.variant_title !== 'Default Title' ? taglia(it.variant_title, testo('tOneSize')) : '';
      importo = it.final_price != null ? it.final_price : it.price;
    }
    var img = it.image ? '<img class="wnn-toast__img" src="' + escape(fotoPiccola(it.image)) + '" alt="" width="80" height="107" loading="lazy">' : '';
    return img + '<div class="wnn-toast__info">' +
      (it.vendor ? '<span class="wnn-toast__brand">' + escape(it.vendor) + '</span>' : '') +
      '<span class="wnn-toast__name">' + escape(it.product_title || it.title || '') + '</span>' +
      (dettaglio ? '<span class="wnn-toast__size">' + escape(dettaglio) + '</span>' : '') +
      (importo != null ? '<span class="wnn-toast__price">' + escape(prezzo(importo)) + '</span>' : '') +
      '</div>';
  }

  function chiudi() {
    if (!toast || toast.hidden) return;
    toast.hidden = true;
    document.documentElement.classList.remove('wnn-toast-aperto');
    var form = document.querySelector('form.product-single__form, [data-wnn-stepper]');
    var ripiego = form && form.querySelector('button:not([disabled]), input:not([disabled]):not([type=hidden]), select, a[href]');
    var dest = ritornoFocus(prima, function (el) { return document.contains(el); }, ripiego);
    if (dest && dest.focus) dest.focus();
    prima = null;
    apertoDa = null;
  }

  function mostra(items, count, titolo) {
    if (!toast) return;
    if (toast.hidden) prima = apertoDa || document.activeElement;
    toast.querySelector('[data-wnn-toast-title]').textContent = titolo || testo('tAdded');
    toast.querySelector('[data-wnn-toast-items]').innerHTML = scheda(items);
    toast.hidden = false;
    document.documentElement.classList.add('wnn-toast-aperto');   // M1: la pagina sotto non scorre
    // ri-avvio dell'animazione anche quando il popup e' gia' aperto: togliere la classe, forzare il ricalcolo, rimetterla.
    toast.classList.remove('wnn-toast--entra');
    void toast.offsetWidth;
    toast.classList.add('wnn-toast--entra');
    var continua = toast.querySelector('[data-wnn-toast-continue]');
    if (continua) continua.focus();
  }

  /* Il contatore in testata oggi si aggiorna perche' la pagina naviga: senza navigazione va aggiornato qui, dallo
     STESSO item_count del riquadro (spec §3.4.5). Il tema ha solo il bollino (.cart-link__bubble), senza numero. */
  function bollino(count) {
    var visibile = typeof count === 'number' && count > 0;
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', visibile);
      b.textContent = visibile ? String(count) : '';
      if (!visibile) return;
      b.classList.remove('cart-link__bubble--wnn-pop');
      void b.offsetWidth;
      b.classList.add('cart-link__bubble--wnn-pop');
    });
  }

  function conteggio() {
    return fetch(theme.routes.cart, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (cart) { return cart.item_count; });
  }

  document.addEventListener('ajaxProduct:added', function (evt) {
    var items = righeDa(evt.detail && evt.detail.product);
    conteggio().then(function (n) { mostra(items, n); if (typeof n === 'number') bollino(n); })
      .catch(function () { mostra(items, null); });    // il riquadro si mostra comunque: l'aggiunta e' riuscita
  });

  document.addEventListener('wnn:cart-updated', function (evt) {
    var d = evt.detail || {};
    mostra(d.items || [], d.item_count, d.aggiornato ? testo('tUpdated') : testo('tAdded'));
    if (typeof d.item_count === 'number') bollino(d.item_count);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form.product-single__form [type=submit], [data-add-to-cart], [data-wnn-confirm]');
    if (b) apertoDa = b;
  }, true);

  if (toast) {
    toast.querySelectorAll('[data-wnn-toast-close], [data-wnn-toast-continue]').forEach(function (b) {
      b.addEventListener('click', chiudi);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') chiudi();
      if (e.key === 'Tab' && !toast.hidden) {
        var items = Array.prototype.filter.call(
          toast.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.getClientRects().length > 0; });
        var dest = prossimoFocus(items, document.activeElement, e.shiftKey);
        if (dest) { e.preventDefault(); dest.focus(); }
      }
    });
  }

  document.addEventListener('shopify:section:load', function (e) { armaForm(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { armaForm(); });
  else armaForm();

  window.WnnCartToast = { mostra: mostra, chiudi: chiudi, bollino: bollino };
})();
